import State from "./State";

export default class LoadMore {
    constructor() {
        this.loadMore = document.querySelector(".js-load-more");
        this.container = document.querySelector(".js-articles");
        this.addEvents();
    }

    addEvents() {
        this.loadMore.addEventListener("click", (e) => {
            e.preventDefault();
            $.ajax({
                type: "GET",
                data: { blogCount: State.blogCount },
                url: "/xhr/getPosts.php",
                success: function success(response) {
                    this.updatePosts(response);
                }.bind(this),
            });
        });
    }

    updatePosts(response) {
        if (response) {
        const responseParsed = JSON.parse(response);
            const articles = responseParsed.articles;
            const totalPosts = responseParsed.totalPosts;
            const noPosts = responseParsed.noPosts;
            this.container.insertAdjacentHTML("beforeend", articles);
            State.blogCount += noPosts;
            if (State.blogCount >= totalPosts) {
                this.loadMore.style.display = "none";
            }
        }
    }
}

document.addEventListener("DOMContentLoaded", function() {
    const loadMore = document.querySelector(".js-load-more");
    if (loadMore) {
        new LoadMore();
        console.log("LoadMore initialized");
    }
});
